import { StyleProps } from '../types';

export const createStyles = ({ isMobile, theme }: StyleProps) => ({
  container: {
    py: 1,
    px: { xs: 1, sm: 2 },
    borderTop: '1px solid',
    borderColor: 'divider',
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
    minHeight: 'auto',
    justifyContent: 'center',
    width: '100%',
    overflow: 'auto',
  },
  mainStack: {
    width: '100%',
    maxWidth: 1200,
    alignItems: { xs: 'stretch', md: 'center' },
    position: 'relative',
  },
  inputFields: {
    width: '100%',
    justifyContent: 'center',
  },
  inputBox: {
    width: { xs: '100%', sm: '50%', md: 300 },
  },
  optionsRow: {
    width: '100%',
    alignItems: { xs: 'flex-start', md: 'center' },
    justifyContent: 'center',
  },
  checkboxes: {
    flexWrap: 'wrap',
    rowGap: 0.5,
  },
  actionButtonsContainer: {
    alignItems: { xs: 'flex-start', sm: 'center' },
    width: { xs: '100%', md: 'auto' },
  },
  buttonGroup: {
    width: isMobile ? '100%' : 'auto',
  },
  button: {
    width: isMobile ? '100%' : 'auto',
  },
  resultsCounter: {
    fontSize: '0.875rem',
    fontWeight: 500,
    textAlign: isMobile ? 'center' : 'left',
    width: isMobile ? '100%' : 'auto',
  },
  textField: {
    backgroundColor: 'background.paper',
    '& .MuiInputBase-root': { fontSize: '0.875rem' },
    m: 0,
  },
  label: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'text.primary',
  },
});
